import cs from 'classnames';
import { Col } from '../col';
import { Row } from '../row';

type P = {
  aside?: React.ReactNode;
  asideLeftColClassName?: string;
  asideRightColClassName?: string;
  asideRowClassName?: string;
  children?: React.ReactNode;
  header?: React.ReactNode;
  headerClassName?: string;
};

const ContentWrapper = ({
  aside,
  asideLeftColClassName,
  asideRightColClassName,
  asideRowClassName,
  children,
  header,
  headerClassName,
}: P) => (
  <div className="content-wrapper">
    {header ? (
      <Row>
        <Col className={cs('content-wrapper__header', headerClassName)}>{header}</Col>
      </Row>
    ) : null}
    {aside ? (
      <Row className={cs('content-wrapper', asideRowClassName)} gutter="ms" wrap={false}>
        <Col className={cs('content-wrapper__aside--left', asideLeftColClassName)}>{children}</Col>
        <Col className={cs('content-wrapper__aside--right', asideRightColClassName)}>{aside}</Col>
      </Row>
    ) : (
      children
    )}
  </div>
);

export default ContentWrapper;
